import api from "@/services/api.js";
import userAccountService from "@/services/user-account.service";
// import mailService from '@/services/mail.service';

export default {
  async login(user) {
    delete api.defaults.headers.common["Authorization"];
    const response = await api.post("/auth/local", {
      identifier: user.email,
      password: user.password,
    });
    if (response.data.jwt) {
      api.defaults.headers.common["Authorization"] =
        "Bearer " + response.data.jwt;

      let storageData = { jwt: "", user: {} };
      storageData.jwt = response.data.jwt;
      storageData.user.id = response.data.user.id;
      storageData.user.username = response.data.user.username;
      storageData.user.first_name = response.data.user.first_name;
      storageData.user.last_name = response.data.user.last_name;
      localStorage.setItem("user", JSON.stringify(storageData));
    }
    return response.data;
  },
  logout() {
    localStorage.removeItem("user");
    delete api.defaults.headers.common["Authorization"];
  },
  async register(user, code = null) {
    delete api.defaults.headers.common["Authorization"];

    const us = {
      first_name: user.firstname,
      last_name: user.lastname,
      email: user.email,
      password: user.password,
      username: user.username,
      confirmed: code ? true : false,
      hide_categories: false,
    };

    const response = await api.post("/auth/local/register", us);
    if (response.data && !us.confirmed) {
      const data = {
        userId: response.data.user.id,
        confirmed: false,
      };

      delete api.defaults.headers.common["Authorization"];
      api.defaults.headers.common["Authorization"] =
        "Bearer " + response.data.jwt;
      const homepages = await api.get("/homepages");
      const defaultHomepage = homepages.data.data.find(
        (h) => h.title === "Min information"
      );
      data.homepage = defaultHomepage;

      await userAccountService.updateUserData(data);
      delete api.defaults.headers.common["Authorization"];
    }

    return response.data;
  },
};
